import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "../../src/Images/logo.png";
import "../Css/Header.css";
function Header() {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 20px",
          gap: "10px",
          marginTop: "-630px",
          marginLeft: "25px",
        }}
      >
        {/* Logo */}
        <img
          src={Image}
          alt="Logo"
          style={{
            height: "110px",
            width: "110px",
            objectFit: "cover",
            padding: "5px",
          }}
        />

        {/* Text beside the logo */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontSize: "30px",
            color: "#F5951B",
          }}
        >
          Gujarati Kshatriya Association USA & Canada
        </Typography>
      </Box>
    </div>
  );
}

export default Header;
